<template>
  <iframe :src="videoURL" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</template>

<script>
let sites = [
  {
    template: "https://www.youtube.com/embed/$1",
    regexes: [
      /youtube.com\/watch\?.*?v=([\w\-]+)/,
      /youtu.be\/([\w\-]+)/
    ]
  },
  {
    template: "https://player.vimeo.com/video/$1",
    regexes: [
      /vimeo\.com\/(\d+)$/,
      /vimeo\.com\/video\/(\d+)$/
    ]
  },
  {
    template: "https://player.vimeo.com/video/$1?h=$2&amp;badge=0&amp;autopause=0&amp;player_id=0",
    regexes: [
      /vimeo\.com\/(\w+)\/(\w+)/,
    ]
  }
]

export default {
  props: ["url"],
  computed: {
    videoURL() {
      return sites.map(site => {
        return site.regexes.map(r => {
          let matches = this.url.match(r)
          if ( matches ) {
            let url = site.template
            for ( let i = 1; i < matches.length; i++ ) {
              url = url.replace(`$${i}`, matches[i])
            }
            return url
          }
        }).find(e => e)
      }).find(e => e)
    }
  }
}
</script>



